/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import { Box, MenuItem, styled } from "@mui/material";
import React from "react";

import MaterialSymbol from "../../../../components/MaterialSymbol";
import Typography from "../../../../components/Typography";

export const StyledMenuItem = styled(MenuItem)({
  paddingLeft: 0,
  paddingRight: 0,
  "&:focus": {
    background: "transparent",
  },
});

export interface SelectableMenuItemProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
  testId?: string;
  dataId?: string;
}

export const SelectableMenuItem: React.FC<SelectableMenuItemProps> = ({
  label,
  selected,
  onToggle,
  testId,
  dataId,
}) => {
  return (
    <StyledMenuItem onClickCapture={onToggle} data-testid={testId} data-id={dataId}>
      <Box display="inline-flex">
        <MaterialSymbol sx={{ opacity: selected ? 1 : 0, color: colors.grey800 }}>
          check
        </MaterialSymbol>
        <Typography
          color={selected ? "grey800" : "primary500"}
          fontWeight={selected ? "bold" : "inherit"}
          variant="body2"
          sx={{ ml: "0.5rem" }}
        >
          {label}
        </Typography>
      </Box>
    </StyledMenuItem>
  );
};
